import { MessageListPage } from './list/list';
import { MessageDetail } from './detail/detail';
import { ReceiptPage } from './receipt/receipt';
import {MsgSettingPage} from './msg-setting/msg-setting';
import {XxtxmsglistPage} from './xxtxmsglist/xxtxmsglist';
import {WddbmsglistPage} from './wddbmsglist/wddbmsglist';

export const MESSAGE_INDEX = [
   MessageListPage,
   MessageDetail,
   ReceiptPage,
   MsgSettingPage,
   XxtxmsglistPage,
   WddbmsglistPage
];


// WEBPACK FOOTER //
// ./src/pages/message/index.ts